import Router from '../../../Src/Modules/Router/Router';
import { isEmpty } from 'lodash/lang';

export default {
    install(app, options) {
        if (isEmpty(options)) {
            throw new Error('Options should have base url.');
        }

        app.config.globalProperties.$router = new Router(options.baseUrl);
    }
}